import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { getIcon } from "../../utils/CommonFunctions";

const styles = theme => ({
  menuItem: {
    fontSize: "12px",
    cursor: "pointer",
    padding: "4px"
  },
  ItemName: {
    fontWeight: "bold",
    paddingLeft: 5,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8rem"
    }
  },
  foodName: {
    padding: "2px"
  },
  foodImg: {
    padding: "2px",
    "& img": {
      width: "10px",
      height: "10px"
    }
  },
  notAvailable: {
    opacity: 0.5,
    cursor: "not-allowed"
  }
});

const MenuCardInSearch = ({ classes, item, onClick }) => {
  return (
    <Grid
      className={`${classes.menuItem} ${
        !item.available ? classes.notAvailable : ""
      }`}
      onClick={() => {
        if (!item.available) return;
        onClick({
          label: item.label || "Searched Items",
          items: [item.foodid]
        });
      }}
    >
      <Grid container direction="row">
        <Grid
          container
          item
          container
          xl={1}
          lg={1}
          xs={1}
          sm={1}
          md={1}
          className={classes.foodImg}
          wrap="nowrap"
          alignItems="center"
          justify="center"
        >
          <img src={getIcon(item.vegflag)} alt="food-type" height='16' width='16' />
        </Grid>
        <Grid
          container
          item
          xs={9}
          sm={9}
          xl={9}
          md={9}
          lg={9}
          justify="space-between"
          direction="column"
          className={classes.foodName}
        >
          <span className={classes.ItemName}>{item.foodname}</span>
        </Grid>
        <Grid
          container
          item
          container
          xs={2}
          sm={2}
          xl={2}
          md={2}
          lg={2}
          className={classes.foodName}
          wrap="nowrap"
          alignItems="center"
          justify="start"
        >
          <span className={`${classes.ItemName}`}>
            {"₹" + (item.preTaxPrice || item.price).toFixed(2)}
          </span>{" "}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(MenuCardInSearch);



// WEBPACK FOOTER //
// ./src/components/AppBar/MenuCardInSearch.js